(function() {
  'use strict';

  angular.module('eclipseApp.core').directive('techTimeSlots', [
    'buyService',
    'buyUtils',
    'notifier',
    'changeTechInstallService',
    'accountDashboardManager',
    'dtmService',
    'dtmServiceConstants',
    'brtSwitchCMS',
    function(
      buyService,
      buyUtils,
      notifier,
      changeTechInstallService,
      accountDashboardManager,
      dtmService,
      dtmServiceConstants,
      brtSwitchCMS
    ) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          props: '=?props',
          timeSlots: '=slots',
          inout: '=?inout',
          mixins: '=?mixins',
          delegate: '=delegate'
        },
        link: function($scope, $elem, $attr) {
          console.log($scope, 'delegate');
          // INITS
          $scope.selectedColumn;
          $scope.props = $scope.props || {};
          $scope.props.state = $scope.props.state || {};

          $scope.fulfillment = {
            loading: false
          };

          $scope.inout.techInstall.selectedSlotId = 'ALL';

          $scope.inout.techInstall.preferredTime = '8AM - 12PM weekdays and weekends';

          $scope.techInstallRules = {
            phone: {
              pattern:
                '(^\\d{3}\\d{3}\\d{4}$)|(^\\d{3}\\s\\d{3}\\s\\d{4}$)|(^\\d{3}\\.\\d{3}\\.\\d{4}$)|(^\\d{3}-\\d{3}-\\d{4}$)'
            }
          };

          if ($scope.delegate === 'myAccount.internet.changeTechInstall') {
            if (
              !changeTechInstallService.currentTechInstallAppointment ||
              !changeTechInstallService.currentTechInstallAppointment.appointmentDate
            )
              return;
            console.log('--SET CAL DATE ', changeTechInstallService.currentTechInstallAppointment.appointmentDate);

            $scope.inout.techInstall.selectedDate =
              changeTechInstallService.currentTechInstallAppointment.appointmentDate;
            initDateWatcher();
          }

          // METHODS
          $scope.parseRowHasAvailableTimeSlots = buyUtils.parseRowHasAvailableTimeSlots;
          $scope.getTime = buyUtils.formatTime;

          $scope.selectSlot = function(index) {
            $scope.selectedColumn = index;
          };

          $scope.setSlots = function(timeSlots) {
            console.log('----@SETSLOTS ($scope)', $scope);

            if ($scope.delegate === 'techInstall') {
              resetSlotScope();
            }

            $scope.timeSlots = buyUtils.parseFormatTimeSlots(timeSlots);

            // set view headers
            $scope.dateHeader = buyService.setTimeSlotsHeader('MMMM D, YYYY', $scope.timeSlots);
            $scope.dayHeader = buyService.setTimeSlotsHeader('dddd', $scope.timeSlots);
          };

          $scope.getNewTimeSlots = function(time) {
            console.log('--FETCHING NEW TIMESLOTS (time, $scope)', time, $scope);

            $scope.inout.techInstall.selectedSlotId = 'ALL';

            // start loading
            $scope.fulfillment.loading = true;

            if ($scope.delegate === 'techInstall' || $scope.delegate === 'fulfillment') {
              console.log('@techTimeSlots:getNewTimeSlots(): --IF1:BUYFLOW BEFORE');

              // if ($scope.inout.forms.fulfillment.__completed && time === $scope.inout.forms.fulfillment.options.techInstall.selectedDate) return;

              console.log('@techTimeSlots:getNewTimeSlots(): --IF1:BUY-FLOW AFTER');

              buyService
                .doOperation('availableTimeslots', {
                  data: {
                    date: moment.parseZone(time).format('YYYY-MM-D')
                  },
                  extendRequestData: true,
                  showProgress: true
                })
                .then(
                  function(res) {
                    notifier.notify.done();
                    $scope.fulfillment.loading = false;
                  },
                  function(res) {
                    $scope.fulfillment.loading = false;
                  }
                );
            } else if ($scope.delegate === 'myAccount.internet.changeTechInstall') {
              console.log('@getNewTimeSlots @ELSEIF myAccount ($scope)', $scope);

              // handle change tech appt

              // NOTE:
              // unhandled: page refresh event

              if (
                !changeTechInstallService.currentTechInstallAppointment ||
                !changeTechInstallService.currentTechInstallAppointment.appointmentDate
              )
                return;

              accountDashboardManager.getTimeSlots(time).then(
                function(resp) {
                  console.log('---@changeTechInstallService:getTimeSlot() ', resp);
                  $scope.inout.techInstall.phone = parseInt(resp.data.contactNumber);
                  $scope.inout.techInstall.instructions = resp.data.specialInstruction;
                  $scope.inout.techInstall.workOrderId = resp.data.workOrderID;
                  $scope.setSlots(resp.data.timeSlots);
                  $scope.fulfillment.loading = false;
                },
                function(respErr) {
                  $scope.fulfillment.loading = false;
                  var dtmServerSideError = 'SS|' + dtmServiceConstants.dtmRules.changeAppointment.defaultServerError;
                  dtmService.setVar(dtmServiceConstants.dtmRules.changeAppointment.eVar, dtmServerSideError);
                  dtmService.direct(dtmServiceConstants.dtmRules.changeAppointment.errorRuleName);
                }
              );

              // /else
            }
          };

          // EVENT LISTENERS
          $scope.$on('Fulfillment:TimeSlots:Updated', function(ev, data) {
            console.log('Fulfillment:TimeSlots:Updated:@data', data);
            $scope.setSlots(data.timeSlots);
          });
          $scope.$on('Events:Fulfillment:ResetScope', function(ev, data) {
            resetSlotScope();
          });

          // fetch time slots everytime techInstall page is loaded
          //
          // case 1 first-landing && tc-only
          // -> do not fetch time-slots
          //
          // case 2 navigateTo
          //  a. fulfillment.not.complete
          //  b. fulfillment.complete
          // -> fetch time-slots
          //
          // case 3 event:refresh
          //  a. fulfillment.not.complete
          //  b. fulfillment.complete
          // -> fetch time-slots

          init($scope.props.state);

          console.log('----@ROOT BE CALLING initDateWatcher()');
          if ($scope.delegate === 'techInstall' || $scope.delegate === 'fulfillment') {
            initDateWatcher();
          }

          function init(state) {
            if (!state) return;
            state = state || {};
            state.fetchOnload = state.fetchOnload || false;

            if ($scope.delegate === 'techInstall' || $scope.delegate === 'fulfillment') {
              if (
                state.fetchOnload ||
                ($scope.mixins.ruiMethods.user.is.agent() && brtSwitchCMS.brtSwitch.isHybridFlow)
              ) {
                console.log('----INIT() @IF WILL BE CALLING getNewTimeSlots() ($scope)', $scope);
                $scope.getNewTimeSlots();
              } else {
                console.log('----INIT() @ELSE WILL BE CALLING setSlots() ($scope)', $scope);
                $scope.setSlots(buyService.getSession('fulfillment').timeSlots);
              }
            } else {
              $scope.getNewTimeSlots();
            }
          }

          function initDateWatcher() {
            var _dereg;

            _dereg = $scope.$watch('inout.techInstall.selectedDate', function(nu, ol) {
              console.log('--WATCHER inout.techInstall.selectedDate (nu, ol)', nu, ol);

              if (ol) {
                // on first landing on fulfillment `ol will be undefined
                // call getNewTimeSlots only if `nu's value is not the same as the `ol value
                // and both `nu and `ol is a valid date – what ever mr moment say
                if (
                  moment(nu).isValid() &&
                  moment(ol).isValid() &&
                  moment(nu).format('YYYY-MM-DD') !== moment(ol).format('YYYY-MM-DD')
                ) {
                  console.log('--WATCHER DATE CHANGED: WILL FETCH NEW TIMESLOTS (nu, ol) ', nu, ol);
                  $scope.getNewTimeSlots(nu);
                }
              }
            });
            return _dereg;
          }

          function resetSlotScope() {
            console.log('@techTimeSlots:resetScope()');
            if ($scope.inout.techInstall.slot) {
              // empty slot in scope
              $scope.inout.techInstall.slot = {};
            } else if ($scope.inout.forms.fulfillment.options.techInstall.slot) {
              // empty slot in scope
              $scope.inout.forms.fulfillment.options.techInstall.slot = {};
            }
          }

          // console.log('@techTimeSlots EOL ($scope)', $scope);
        },
        templateUrl: 'modules/core/views/tech-time-slots-directive.html'
      };
    }
  ]);
})();
